import { Component, h, Prop, Event, type EventEmitter } from '@stencil/core';
import type { labelProviderInterface } from '../../LabelProviderInterface';

@Component({
  tag: 'uiaas-search-widget-product-catalog',
  styleUrl: 'product-catalog.scss',
  shadow: true
})
export class WidgetProductCatalog {
  @Prop() readonly labelProvider?: labelProviderInterface;

  @Event({
    eventName: 'search:productCatalogWidgetClicked',
    composed: true,
    cancelable: true,
    bubbles: true
  })
    eventEmitterProductCatalogWidgetClicked: EventEmitter;

  render() {
      return (
        <div class="widget-container">
          <a
            class="header"
            onClick={(e) => this.onClickPublisher(e)}
            target="_self"
            tabindex="0"
          >
            <div class="content">
              <section class="widget-global-icon">
                <se-icon size="large">web_sdk</se-icon>
              </section>
              <section class="widget-content">
                <span class="widget-title">{this.labelProvider('product.catalog.widget.title', 'Browse results from the global and local catalog')}</span>
                <div class="label-list">
                  <span class="widget-details">
                    {this.labelProvider('product.catalog.widget.content', 'Both catalogs are available for viewing products, documents, and software.')}
                  </span>
                </div>
              </section>
              <section class="widget-icon">
                <se-icon size="medium">arrow2_right</se-icon>
              </section>
            </div>
          </a>
        </div>
      );
  }

  private onClickPublisher(e: Event) {
      e.preventDefault();
      e.stopPropagation();
      this.eventEmitterProductCatalogWidgetClicked.emit({});
      window.sessionStorage.setItem('productCatalogWidgetClicked', 'true');
  }
}
